import { fromUnixTime, isValid, parse } from 'date-fns';
/**
 * Пытается преобразовать входное значение в объект Date.
 *
 * Поддерживает:
 * - number (timestamp в секундах или миллисекундах)
 * - string (с указанным форматом или через new Date)
 * - Date
 *
 * Если значение некорректно или дата невалидна — возвращает null.
 *
 * @example
 * parseDateInput(1704067200) // секунды
 * parseDateInput(1704067200000) // миллисекунды
 * parseDateInput('01.01.2024', { format: 'dd.MM.yyyy' })
 */
export function parseDateInput(
  input: unknown,
  options?: {
    format?: string;
  },
): Date | null {
  if (!input) {
    return null;
  }

  if (typeof input === 'number' && Number.isFinite(input)) {
    const date =
      input < 10_000_000_000
        ? fromUnixTime(input) // секунды
        : new Date(input); // миллисекунды

    return isValid(date) ? date : null;
  }

  if (typeof input === 'string') {
    if (options?.format) {
      const parsed = parse(input, options.format, new Date());
      return isValid(parsed) ? parsed : null;
    }

    const parsed = new Date(input);
    return isValid(parsed) ? parsed : null;
  }

  if (input instanceof Date) {
    return isValid(input) ? input : null;
  }

  return null;
}
